import { useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { IProductGroupCategory } from '@cbgms/api'
import { buildProductGroupURL } from 'app/products/components/ProductGroups/useGotoProductGroup'
import { Crumb } from '@carsys/ui'

interface Props {
  path: string
  productGroups: IProductGroupCategory[]
}

export const useProductGroupCrumbs = ({ productGroups, path }: Props) => {
  const flatProductGroups = useMemo(() => {
    const parents: {
      [key: string]: {
        ParentID: string
        Name: string
      }
    } = {}
    function flatten(group: IProductGroupCategory, parent: string) {
      parents[group.ID] = {
        ParentID: parent,
        Name: group.Name
      }
      group.Categories && group.Categories.forEach(g => flatten(g, group.ID))
    }
    productGroups && productGroups.length && productGroups.forEach(g => flatten(g, ''))
    return parents
  }, [productGroups])

  const listParents = (id: string) => {
    let curr = id
    const out: {
      ID: string
      Name: string
    }[] = []
    while (curr) {
      if (!flatProductGroups[curr]) {
        return out
      }
      out.unshift({
        ID: curr,
        Name: flatProductGroups[curr].Name
      })
      curr = flatProductGroups[curr].ParentID
    }
    return out
  }
  const p = useRouteMatch<{ productGroupUUID: string }>({ path })

  if (!p || !p.params.productGroupUUID) {
    return null
  }

  const nodes = listParents(p.params.productGroupUUID)

  return nodes.map((node, index) => {
    return (
      <Crumb
        data-testid={`crumb-workorders-view-product-groups-view-${node.ID}`}
        key={node.ID}
        path='/'
        to={buildProductGroupURL(p.url, node.ID)}
        forceAsFinalNode={index === nodes.length - 1}
        text={node.Name.toLowerCase()}
      />
    )
  })
}
